import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
  standalone: false,
  selector: 'bt-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent implements OnChanges {

  @Input() public pageNumber: number;
  @Input() public pageSize: number;
  @Input() public totalNumber: number;

  @Output() public clickPage = new EventEmitter<number>();

  public startNumber: number;
  public endNumber: number;

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.pageNumber || changes.totalNumber || changes.pageSize) {
      if (this.pageSize && this.totalNumber) {
        this.startNumber = this.pageNumber * this.pageSize + 1;
        const end = this.startNumber + this.pageSize - 1;
        this.endNumber = end > this.totalNumber ? this.totalNumber : end;
      } else {
        this.startNumber = 0;
        this.endNumber = 0;
        this.totalNumber = this.totalNumber || 0;
      }
    }
  }

  public onClickPage(page: number) {
    this.clickPage.emit(page);
  }
}
